/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Downgrade_Addon_Price_ChangesInputs */



/**
* | output |
* | --- |
* | "Add-on price changes" |
*
* @param {Sub_Downgrade_Addon_Price_ChangesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_addon_price_changes = /** @type {((inputs?: Sub_Downgrade_Addon_Price_ChangesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Addon_Price_ChangesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Add-on-Preisänderungen")
	return /** @type {LocalizedString} */ ("Add-on price changes")
});